import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  marginFields: {
    marginTop: 15
  }
}));
